import React, { useState, useEffect } from "react";
import Layout from "./layout";
import Products from "./pages/products";
import AnalyticsDashboard from "./pages/analyticsdashboard";
import Commissions from "./pages/commissiondashboard";
import ReportSettings from "./pages/reportsettings";
import MessagingSettings from "./pages/messagingsettings";       // ← NEW
import BackendInstaller from "./components/backendinstaller";
import { api, checkBackend } from "./services/api";

export default function App() {
  const [backendReady, setBackendReady] = useState(null);
  const [activePage, setActivePage]     = useState("analytics");
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    async function test() {
      const ok = await checkBackend();
      setBackendReady(ok);
    }
    test();
  }, []);

  const handleSearch = async (query) => {
    if (!query) { setSearchResults([]); return; }
    try {
      const res = await api.get(`/search/products?q=${encodeURIComponent(query)}`);
      setSearchResults(res.data);
    } catch (err) {
      console.error("Search error", err);
    }
  };

  if (backendReady === null) {
    return (
      <div className="flex items-center justify-center h-screen">
        Checking Companion Service...
      </div>
    );
  }

  if (!backendReady) return <BackendInstaller />;

  return (
    <Layout activePage={activePage} setActivePage={setActivePage} onSearch={handleSearch} searchResults={searchResults}>
      {activePage === "analytics"          && <AnalyticsDashboard />}
      {activePage === "commissions"        && <Commissions />}
      {activePage === "products"           && <Products searchResults={searchResults} />}
      {activePage === "report-settings"    && <ReportSettings />}
      {activePage === "messaging-settings" && <MessagingSettings />}  {/* ← NEW */}
    </Layout>
  );
}